import React from 'react';
import {ReactComponent as Tick} from '../assets/tick.svg';

const ServiceCardList = () =>{
    
  const cardList = [
      {
        title: "Planning & Feasibility Studies"
      },
      {
        title: "Project Formulation, Appraisal and Planning"
      },
      {
        title: "Economic and Financial Analysis"
      },
      {
        title: "Road and Highway Design"
      },
      {
        title: "Transport and Traffic Engineering"
      },
      {
        title: "Pavement Engineering"
      },
      {
        title: "Bridge and Structural Engineering"
      },
      {
        title: "Geotechnical Engineering"
      },
      {
        title: "Road Safety Engineering"
      },
      {
        title: "Hydrology and Drainage"
      },
      {
        title: "Surveying, Geomatics and GIS"
      },
      {
        title: "Environmental and Social Studies"
      },
      {
        title: "Urban Planning and Landscape Design"
      },
      {
        title: "Architectural and Building Services"
      },
      {
        title: "Irrigation and Water Resources"
      },
      {
        title: "Water Supply, Sanitation and Wastewater"
      },
      {
        title: "Energy and Electromechanical Engineering"
      },
      {
        title: "Quantity Surveying and Cost Engineering"
      },
      {
        title: "Tender Documentation and Procurement"
      },
      {
        title: "Contract Administration and Construction Supervision"
      },
      {
        title: "Project Management, Monitoring and Control"
      },
      {
        title: "Design Review and Quality Assurance"
      }
    ]
        
    return cardList.map((data,id) =>{
        return (
            <div className={`card hidden`} key={id} id='services-card'>
            {/* <img src={tick} alt="the tick" className='tick'/> */}
            <Tick className='tick'/>
            <p>
              {data.title}
            </p>
          </div>
        )
    })
}

  export default ServiceCardList;